import { Component } from '@angular/core';
import { EventSearchType } from '../../../../models/_enum-collections';
import { EventTableComponent } from '../event-table/event-table.component';

@Component({
  selector: 'app-all-events',
  templateUrl: './all-events.component.html',
  styleUrls: ['./all-events.component.scss'],
  standalone: true,
  imports: [EventTableComponent]
})
export class AllEventsComponent {
  loading!: boolean;

  get EventSearchType(): typeof EventSearchType {
    return EventSearchType;
  }
}
